import React from "react";

/**
 * Setu — Cable-stayed bridge monogram.
 *
 * Inspired by the Bandra-Worli Sea Link / Signature Bridge silhouette:
 *   • Central pylon rising above the deck
 *   • Cables fanning symmetrically from the pylon top to the deck
 *   • A soft water line beneath (two horizontal ripples)
 *
 * Reads instantly as a modern, engineered bridge — unmistakably Indian,
 * unmistakably "Setu". Uses currentColor so it inherits any text color.
 */
export const SetuMark = ({ size = 32, className = "", strokeWidth = 2 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-label="Setu logo"
    role="img"
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {/* Deck / roadway */}
    <line x1="3" y1="21" x2="29" y2="21" strokeWidth={strokeWidth * 1.15} />

    {/* Central pylon — tall vertical rising above deck */}
    <line x1="16" y1="21" x2="16" y2="4" strokeWidth={strokeWidth * 1.15} />

    {/* Cables fanning from pylon top — symmetric spread */}
    <line x1="16" y1="6" x2="6"  y2="21" strokeWidth={strokeWidth * 0.55} opacity="0.9" />
    <line x1="16" y1="6" x2="10" y2="21" strokeWidth={strokeWidth * 0.55} opacity="0.9" />
    <line x1="16" y1="6" x2="22" y2="21" strokeWidth={strokeWidth * 0.55} opacity="0.9" />
    <line x1="16" y1="6" x2="26" y2="21" strokeWidth={strokeWidth * 0.55} opacity="0.9" />

    {/* Pylon top cap — keystone dot */}
    <circle cx="16" cy="4" r="1.8" fill="currentColor" stroke="none" />

    {/* Water ripples beneath the deck */}
    <path d="M 4 26 Q 8 24.5 12 26 T 20 26 T 28 26"
      strokeWidth={strokeWidth * 0.55} opacity="0.4" />
    <path d="M 6 29 Q 10 28 14 29 T 22 29"
      strokeWidth={strokeWidth * 0.45} opacity="0.25" />
  </svg>
);

/**
 * Setu logo — mark + wordmark side-by-side.
 * Wordmark uses the display serif (Instrument Serif) for editorial feel.
 */
export const SetuLogo = ({ size = 32, showText = true, className = "" }) => (
  <div className={`inline-flex items-center gap-2.5 ${className}`}>
    <div
      className="grid place-items-center rounded-md bg-primary text-primary-foreground"
      style={{ width: size, height: size }}
    >
      <SetuMark size={size * 0.72} strokeWidth={2} />
    </div>
    {showText && (
      <span className="font-display text-2xl tracking-tight leading-none">Setubuild.OS</span>
    )}
  </div>
);

export default SetuLogo;
